import type { ZenkraftDimUnit, ZenkraftPackageDimensions } from "../services/zenkraft/types";

export const ZENKRAFT_NON_PDF_RESPONSE_SNIPPET_MAX_LENGTH = 200;

// 250g coffee bag, per the packaging size guide. Two sets because dim_units on the shipment template
// decides how the carrier reads the numbers — metric for BUK/BAU/BDE, imperial for BUS roasters.
// Both sets clear Australia Post's "at least 2 dimensions >= 5cm" rule (error 42011).
export const SMALL_COFFEE_BAG_DIMENSIONS: Record<ZenkraftDimUnit, ZenkraftPackageDimensions> = {
  CM: { height: 18.5, length: 11, width: 6 },
  IN: { height: 8.5, length: 5, width: 3 },
};

export const resolvePackageDimensions = (dimUnits: string | undefined): ZenkraftPackageDimensions =>
  dimUnits === "IN" ? SMALL_COFFEE_BAG_DIMENSIONS.IN : SMALL_COFFEE_BAG_DIMENSIONS.CM;
